import {observer} from 'mobx-react-lite'
import React from 'react'
import {useTaskStore} from '@components/my-tasks/tasks-list/task-store'
import {TaskMenuOnly} from '@components/task-menu/task-menu-only'
import {TaskMenuVisibleItems} from '../../../task-menu/task-menu-new'

interface TaskMenuProps {
  element: HTMLElement
  isSubTask: boolean
  closeMenu: () => void
  rename: () => void
  addSubTask: () => void
}

const visibleMenuItems: TaskMenuVisibleItems[] = [
  'add-subtask',
  'rename-task',
  'complete-task',
  'make-public',
  'move-task',
  'link',
  'upload-cover',
  'task-colorpicker',
  'delete'
]

export const TaskMenu = observer((props: TaskMenuProps) => {
  const [_, store] = useTaskStore()
  const {element, closeMenu, rename} = props

  const hub = store.taskHub
  if (!hub || !store.taskItem) {
    return null
  }

  return (
    <>
      <TaskMenuOnly
        task={store.taskItem}
        rename={rename}
        fromWhere="my-tasks"
        reference={element}
        onCloseRequest={() => {
          closeMenu()
        }}
        visibleItems={visibleMenuItems}
      />
    </>
  )
})
